export default __webpack_public_path__ + "static/media/bandeira-da-espanha.9400bf33.svg";